import { useDashboardColor } from "../context/DashboardColorContext";

interface BannerRibbonProps {
    text: string;
}

const BannerRibbon = ({ text }: BannerRibbonProps) => {
    const color = useDashboardColor();

    return (
        <div className="flex items-center mb-4">
            <div 
                className="mx-auto w-full text-center py-1 rounded-full text-white font-semibold shadow-sm" 
                style={{ backgroundColor: color }}
            >
                {text}
            </div>
        </div>

        // Legacy
        // <div
        //     className="border py-2 mb-4 flex flex-col items-center justify-center h-7 w-full"
        //     style={{ backgroundColor: color }}
        // >
        //     <h2 className="font-bold text-white text-center">{text}</h2>
        // </div>
    );
};
  
export default BannerRibbon;


